<template>
  <div class="w-[80%] mx-auto flex flex-col items-center h-full">
    <DatePicker
      :mode="'range'"
      borderless
      expanded
      :attributes="highlightedDates"
      @dayclick="handleDayClick"
      class="rounded-bl-2xl rounded-br-2xl"
    />
    <p
      v-if="highlightedDates[0]?.dates[0][0]"
      class="flex flex-col md:flex-row items-center text-lg mt-6 font-semibold"
    >
      От&nbsp;<span class="text-blue-500 mx-6">{{
        convertDates(highlightedDates[0]?.dates[0][0])
      }}</span
      >&nbsp; До&nbsp;<span class="text-orange-500 mx-6">{{
        convertDates(highlightedDates[0]?.dates[0][1])
      }}</span>
    </p>
    <button
      @click="checkCarsAvailability"
      class="bg-active text-white font-bold rounded-full py-4 px-8 mt-6"
      :class="{ 'opacity-50': !highlightedDates[0]?.dates[0][1] }"
      :disabled="!highlightedDates[0]?.dates[0][1]"
    >
      Виж наличните автомобили
    </button>
  </div>
</template>

<script>
import { DatePicker } from "v-calendar";
import "v-calendar/style.css";
import axios from "axios";

export default {
  name: "SelectDates",
  components: {
    DatePicker,
  },
  data() {
    return {
      pickingStartDate: true, // Track if we're picking the start date
      highlightedDates: [],
    };
  },
  methods: {
    handleDayClick(day) {
      if (this.pickingStartDate) {
        // If we're picking the start date, set the start of the range
        this.highlightedDates = [
          {
            highlight: {
              backgroundColor: "green",
            },
            dates: [[day.id, day.id]],
          },
        ];
        this.pickingStartDate = false;
      } else {
        // If we're picking the end date, set the end of the range
        this.highlightedDates[0].dates[0][1] = day.id;
        this.pickingStartDate = true;
      }
    },
    convertDates(date) {
      const months = [
        "Януари",
        "Февруари",
        "Март",
        "Април",
        "Май",
        "Юни",
        "Юли",
        "Август",
        "Септември",
        "Октомври",
        "Ноември",
        "Декември",
      ];
      const dateObj = new Date(date);
      const day = dateObj.getDate();
      const month = months[dateObj.getMonth()];
      const year = dateObj.getFullYear();
      return `${day} ${month} ${year}`;
    },
    async checkCarsAvailability() {
      const startDate = this.highlightedDates[0]?.dates[0][0];
      const endDate = this.highlightedDates[0]?.dates[0][1];

      // convert to dd.mm.yyyy
      let formattedStartDate = new Date(startDate).toLocaleDateString("bg-BG");
      formattedStartDate = formattedStartDate.replace(/ /g, "");
      formattedStartDate = formattedStartDate.replace("г.", "");

      let formattedEndDate = new Date(endDate).toLocaleDateString("bg-BG");
      formattedEndDate = formattedEndDate.replace(/ /g, "");
      formattedEndDate = formattedEndDate.replace("г.", "");

      const res = await axios.post(
        "https://car-booking-api.g-home.site/api/cars/availability",
        {
          start_date: formattedStartDate,
          end_date: formattedEndDate,
        }
      );
      const data = res.data.cars;
      const brands = [...new Set(data.map((car) => car.brand))];

      this.$emit("step", {
        data,
        brands,
        formattedStartDate,
        formattedEndDate,
      });
    },
  },
};
</script>
